import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { FormType, InterestInstructions, MarketingPreference } from '../types';
import { CheckBox, Radio, Select, TextArea, TextFiled } from 'tsx/comps/form';
import { get } from 'lodash';
import { useEffect } from 'react';

const Div = styled.div``;

interface Step5Props {
  onNext: () => void;
  onPrev: () => void;
}

export const Step5: React.FC<Step5Props> = ({ onNext, onPrev }) => {
  const { values, handleChange, handleBlur, touched, errors, setFieldValue, setFieldTouched, validateField } =
    useFormikContext<FormType>();

  // console.log('ERRORS: ', errors.personalInformation);
  // console.log('VALUES: ', values.personalInformation);

  const validate = () => {
    const timer = setTimeout(() => {
      validateField('interestRequirement');
      clearTimeout(timer);
    }, 1);
  };

  useEffect(() => {
    validate();
  }, [values.personalInformation]);

  return (
    <Div>
      <h2>Use of your Personal Information</h2>
      <div className="spc30" />
      <p>
        We are a data controller of your personal information. The way that we process your personal information is
        described in our Privacy Notice. This information is available on our website www.chorleybs.co.uk/privacy. From
        time to time the Society will send you information about other products and services we offer by post. We will
        only do this where we believe we have a legitimate interest to do so and it is not to the detriment of your
        interests, fundamental rights and freedoms. More information can be found in our privacy notice. We also want to
        provide you with this information by Email and Telephone. If you do wish to receive such material by these
        methods then please tick the appropriate boxes.
      </p>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Applicant 1 Marketing Preference</span>
          <div className="radio-container">
            {Object.entries(MarketingPreference).map(([key, value]) => (
              <div key={key} className="radio-container__item">
                <Radio
                  checked={values.personalInformation.applicant1MarketingPreference === value}
                  onChange={() => setFieldValue('personalInformation.applicant1MarketingPreference', value)}
                />
                <p className="radio-container__item__label">{key}</p>
              </div>
            ))}
          </div>
        </div>
        {values.secondAccountHolderPersonalDetails && (
          <div>
            <span className="label">Applicant 2 Marketing Preference</span>
            <div className="radio-container">
              {Object.entries(MarketingPreference).map(([key, value]) => (
                <div key={key} className="radio-container__item">
                  <Radio
                    checked={values.personalInformation.applicant2MarketingPreference === value}
                    onChange={() => setFieldValue('personalInformation.applicant2MarketingPreference', value)}
                  />
                  <p className="radio-container__item__label">{key}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="spc30" />
      <h6>
        We work closely with Accord Legal Services, who provide a Will writing and estate planning service, ensuring
        your assets and loved ones are protected in the best way.
      </h6>
      <div className="spc30" />
      <div className="checkbox-field">
        <CheckBox
          onSelect={(val) => setFieldValue('personalInformation.isPersonalAccountTransfer', val)}
          checked={values.personalInformation.isPersonalAccountTransfer}
        />
        <p>
          I/we acknowledge that transfers of fund into this account must originate from my personal sole and or joint
          current account or savings account.
        </p>
      </div>
      <div className="spc10" />
      <p className="sub-text">
        Alternatively visit our website{' '}
        <a href="https://www.chorleybs.co.uk/life-planning" target="_blank">
          www.chorleybs.co.uk/life-planning
        </a>
      </p>
      <div className="spc30" />
      <h6>
        We also work closely with PG Mutual, who provide Income Protection Insurance to cover income, if you found
        yourself unable to work due to illness or accident and unable to meet your financial commitments.
      </h6>
      <div className="spc30" />
      <div className="checkbox-field">
        <CheckBox
          onSelect={(val) => setFieldValue('personalInformation.wantsToBeContactedByPGMutual', val)}
          checked={values.personalInformation.wantsToBeContactedByPGMutual}
        />
        <p>If you would like to be contacted by PG Mutual please tick here.</p>
      </div>
      <div className="spc10" />
      <p className="sub-text">
        Alternatively you can get a quotation for this cover via our website{' '}
        <a href="https://www.chorleybs.co.uk/life-planning" target="_blank">
          www.chorleybs.co.uk/life-planning
        </a>
      </p>
      <div className="spc30" />
      <p>
        After you submit this form your data will be used to authenticate your identity with a fraud prevention agency
        and to start the creation of your account.
      </p>

      {/* END */}
      <div className="spc30" />
      <div className="spc10" />
      <div className="buttons">
        <button className="btn btn--secondary" onClick={onPrev}>
          Previous
        </button>
        <button className="btn" onClick={onNext} disabled={!!errors.personalInformation}>
          Next
        </button>
      </div>
    </Div>
  );
};
